export const GAME_LAUNCH_DATE = new Date(2022, 9, 19, 15, 0, 0)
export const INVITE_COOKIE_NAME = "inviting_user"
export const FROM_FB_COOKIE_NAME = "from_fb_landing"
